import { insuranceImportService } from "./service";
import { InsuranceImport, InsuranceImportUpdateRequest } from "./types";

export const updateInsuranceImport = async (
  insuranceImportId: string,
  request: InsuranceImportUpdateRequest
) => {
  const { data } = await insuranceImportService.patch<InsuranceImport>(
    `/${insuranceImportId}`,
    request
  );

  return data;
};
